import React from "react";

import Svg, { Path, G } from "components/Svg";

const Exhaust = props => (
	<Svg
		width={18 * props.scale}
		height={15 * props.scale}
		viewBox="0 0 52 40.8"
	>
		<Path
			fill={props.fill || "white"}
			d="M52,16.4c-2.8,2.7-6.4,3.3-11.3,2.8a22.264,22.264,0,0,0-.5-3.6c8.4.6,10.8-4.1,11.8-6.8-3.2,3.1-7.4,3.5-13.4,2.5A20.249,20.249,0,0,0,20.4,0,20.4,20.4,0,1,0,37.8,31c10.3,1.7,13.1-3.7,14.2-6.6-3,2.9-6.9,3.4-12.3,2.7a22.213,22.213,0,0,0,.9-3.7C48.6,23.8,51,19.1,52,16.4ZM36.7,26.6c-1.5-.3-3.1-.6-4.9-1-9.7-3.1-18.5,6.7-18.5,6.7a27.256,27.256,0,0,1,21.5-2,17.311,17.311,0,0,1-14.4,7.6A17.45,17.45,0,1,1,34.7,10.5c-.9-.2-1.9-.4-2.9-.7-9.7-3.1-18.5,6.7-18.5,6.7,9.3-4.6,16.4-3.7,23.7-1.4a15.278,15.278,0,0,1,.7,3.6c-1.8-.3-3.8-.7-5.9-1.2-9.7-3.1-18.5,6.7-18.5,6.7,9.4-4.7,16.7-3.7,24.1-1.3h.3A27.97,27.97,0,0,1,36.7,26.6Z"
		/>
	</Svg>
);

export default Exhaust;



// WEBPACK FOOTER //
// ./src/components/svgs/Exhaust/index.js